const arraySearch = <T>(key: keyof T, value: T[keyof T], src: T[]): T | undefined => {
  for (const item of src) {
    if (item[key] === value) return item;
  }
  return undefined;
};
export default arraySearch;
